export var QueryKind;
(function (QueryKind) {
    QueryKind["KIND_EXECUTE"] = "execute";
    QueryKind["KIND_EXECUTE_MANY"] = "execute-many";
})(QueryKind || (QueryKind = {}));
var Query = /** @class */ (function () {
    function Query() {
        this.isExpanded = false;
    }
    Object.defineProperty(Query.prototype, "searchableSql", {
        get: function () {
            if (this._searchableSql == null) {
                this._searchableSql = this.sql.toLowerCase();
            }
            return this._searchableSql;
        },
        enumerable: false,
        configurable: true
    });
    Query.prototype.matches = function (searchText) {
        return this.searchableSql.indexOf(searchText) != -1;
    };
    Object.defineProperty(Query.prototype, "durationDisplay", {
        get: function () {
            if (this._durationDisplay == null) {
                this._durationDisplay = "".concat((this.duration * 1000000).toFixed(2), " \u00B5s");
            }
            return this._durationDisplay;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Query.prototype, "timestampDisplay", {
        get: function () {
            if (this._timestampDisplay == null) {
                this._timestampDisplay = new Date(this.timestamp_iso).toLocaleString();
            }
            return this._timestampDisplay;
        },
        enumerable: false,
        configurable: true
    });
    return Query;
}());
export { Query };
